import classnames from 'classnames';
import React__default from 'react';
import Input from '../../../Input/index.js';
import { useTable } from '../utils/hooks.js';
import { getSelectedRow } from './utils.js';

var SelectionCell = function SelectionCell(_ref) {
  var _columns$columnDefs$f, _columns$columnDefs$;
  var dataTestId = _ref.dataTestId,
    pinned = _ref.pinned,
    rowId = _ref.rowId,
    rowSelection = _ref.rowSelection,
    showGrid = _ref.showGrid,
    singleRowData = _ref.singleRowData,
    tableName = _ref.tableName;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    columns = _useTable$state.columns,
    groupDisplayType = _useTable$state.groupDisplayType,
    selectedRows = _useTable$state.selectedRows,
    onRowSelect = _useTable$state.onRowSelect;
  var rowLabel = groupDisplayType ? singleRowData[(_columns$columnDefs$f = columns.columnDefs.find(function (_ref2) {
    var rowGroup = _ref2.rowGroup;
    return !rowGroup;
  })) === null || _columns$columnDefs$f === void 0 ? void 0 : _columns$columnDefs$f.field] //get the first non group column def for the field
  : singleRowData[(_columns$columnDefs$ = columns.columnDefs[0]) === null || _columns$columnDefs$ === void 0 ? void 0 : _columns$columnDefs$.field];
  if (!rowId) {
    console.error('Hey Canvas User! Table row selection requires a unique row id.');
  }
  var hasRowSelection = !!rowSelection;
  var isChecked = function isChecked(selectedRows, rowId) {
    if (Array.isArray(selectedRows)) {
      return selectedRows.includes(rowId);
    }
  };
  var columnClasses = classnames('C-TableAdvanced__bodyCell', {
    '--pinned': pinned,
    '--showGrid': showGrid
  });
  var isSelectedRow = isChecked(selectedRows, rowId);
  return hasRowSelection && /*#__PURE__*/React__default.createElement("td", {
    className: columnClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(rowId, "-selection-cell") : null
  }, /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    checked: isSelectedRow,
    "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(rowId, "-selection-cell-checkbox") : null,
    "aria-label": "".concat(isSelectedRow ? 'Deselect' : 'Select', " row ").concat(rowLabel),
    id: "".concat(tableName, "-row-").concat(rowId) //use tableName in case multiple tables
    ,
    onChange: function onChange(event) {
      var selection = getSelectedRow(selectedRows, rowId, event.target.checked);
      onRowSelect && onRowSelect(selection);
    }
  }));
};

export { SelectionCell as default };
